import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { BehaviorSubject, Observable } from 'rxjs';

export interface TitleConfig {
  title: string;
  breadcrumbs?: { 
    text: string;
    route?: string[];
  }[];
}

@Injectable({
  providedIn: 'root',
})
export class CustomTitleService {
  private titleSubject: BehaviorSubject<TitleConfig> = new BehaviorSubject<TitleConfig>({ title: '' });
  public title$: Observable<TitleConfig> = this.titleSubject.asObservable();

  constructor(private titleService: Title) {}

  /**
   * Sets the page title both in browser tab and for the header
   * @param title New title to display
   */
  setTitle(title: string): void {
    // Update the browser tab title
    this.titleService.setTitle(title);
    
    // Update our custom title Observable for the header
    this.titleSubject.next({ title });
  }

  /**
   * Sets the page title with optional breadcrumbs
   * @param config Title configuration with optional breadcrumbs
   */
  setTitleWithBreadcrumbs(config: TitleConfig): void {
    // Update the browser tab title
    this.titleService.setTitle(config.title);
    
    // Update our custom title Observable for the header
    this.titleSubject.next(config);
  }

  /**
   * Gets the current page title
   */
  getTitle(): string {
    return this.titleSubject.getValue().title;
  }
}
